export default __webpack_public_path__ + "static/media/authImg2.8064b996.jpg";